import React, { Component } from 'react'
import ProductList from './ProductList'
import CloseBtn from './svg/CloseBtn'
import EuroColdCatagoryList from './EuroColdCatagoryList'
import { connect } from 'react-redux'
import { getEurocoldCatagory } from '../actions/MainAction'

export class EuroColdListSection extends Component {
    componentDidMount() {
        this.props.getEurocoldCatagory();
    }

    handleSubCategoryClick = (subId) => {
        if (this.props.onSubCategorySelect) {
            this.props.onSubCategorySelect(subId); // <-- Grandparent-ə ötürür
        }
    }

    render() {
        const { eurocoldCatagoryData, closeMenu } = this.props;
        // console.log(eurocoldCatagoryData)
        return (
            <section className=' max-[1024px]:bg-[var(--body)] bg-[#fff] rounded-[8px] max-[1024px]:rounded-[0px]'>
                <div className='hidden p-[24px_40px] max-[1024px]:flex max-[1024px]:justify-between '>

                    <div className=''>
                        <h2 className='font-[500] text-[18px] text-[#272727]'>Kataloq</h2>
                    </div>
                    <button onClick={closeMenu} className='mr-[20px]'><CloseBtn /></button>{/*onClick={closeMenu}*/}
                </div>

                <div className=' flex flex-col  gap-[20px] m-[0_15px_0_0] rounded-[8px] w-[320px] max-[1024px]:w-full p-[24px_40px] min-h-[100vh]'>

                    {eurocoldCatagoryData?.map((data, i) => {
                        return (
                            <EuroColdCatagoryList
                                key={i}
                                catagory={data?.title}
                                id={data?.id}
                                onSubCategoryClick={this.handleSubCategoryClick}
                            />

                        )
                    })

                    }


                </div>
            </section>
        )
    }
}


const mapStateProps = (state) => ({
    eurocoldCatagoryData: state.Data.eurocoldCatagoryData
})

const mapDispatchToProps = { getEurocoldCatagory }
export default connect(mapStateProps, mapDispatchToProps)(EuroColdListSection)